import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

import { Facebook, Twitter } from "./socialMedia"

export interface SeoProps {
  /**
   * title of the page
   */
  title?: string
  /**
   * image path from the static folder, example "images/sample-image.jpeg"
   */
  banner?: string
  /**
   * description of the page
   */
  description?: string
  /**
   * path of the page example "components/marketing", it will be added to the website base URL.
   */
  pathName?: string
  /**
   * Provide the type of the page, more information https://ogp.me/
   */
  type?: string
  /**
   * ideas and topics that define what your content is about
   */
  keywords?: string
  /**
   * data from websites to promote search results
   */
  ldJSON?: string
  /**
   * instructions given to search engines robots, example "noindex, nofollow"
   */
  robots?: string
}

const query = graphql`
  query SEO {
    site {
      buildTime(formatString: "YYYY-MM-DD")
      siteMetadata {
        siteUrl
        defaultTitle: title
        defaultDescription: description
        defaultBanner: banner
        language
        pagekeywords: keywords
        ogLanguage
        author
        twitter
        facebook
      }
    }
  }
`
export const SEO: React.FC<SeoProps> = ({
  title,
  description,
  banner,
  pathName,
  type,
  keywords,
  robots,
  ldJSON,
}) => {
  const { site } = useStaticQuery(query)

  const {
    siteMetadata: {
      siteUrl,
      defaultTitle,
      defaultDescription,
      defaultBanner,
      pageKeywords,
      language,
      ogLanguage,
      twitter,
      facebook,
    },
  } = site

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}/${banner || defaultBanner}`,
    keywords: keywords || pageKeywords,
    url: `${siteUrl}/${pathName || ""}`,
  }

  return (
    <>
      <Helmet title={seo.title}>
        <html lang={language} />
        <meta name="description" content={seo.description} />
        <meta name="author" content={facebook} />
        <meta name="keywords" content={seo.keywords} />
        {robots !== undefined ? <meta name="robots" content={robots} /> : ""}
        {ldJSON && <script type="application/ld+json">{ldJSON}</script>}
        <link rel="canonical" href={seo.url} />
      </Helmet>
      {/* Social Media markups */}
      <Facebook
        desc={seo.description}
        image={seo.image}
        title={seo.title}
        type={type ? `${type}` : "website"}
        url={seo.url}
        locale={ogLanguage}
        name={facebook}
      />
      <Twitter />
    </>
  )
}

export default SEO
